import { getStore } from '../store/store';

/**
 * Gets the ID of the active drawer pane for the specified window.
 *
 * @param tabId - The ID of the tab for which to get the active drawer pane.
 * @returns The ID of the active drawer pane, or undefined if no active pane is found.
 */
export default function getActiveDrawerPane(tabId: string): string | undefined {
    return getStore().activePanes.get(tabId);
}
